import { render, staticRenderFns } from "./UserWatchlist.vue?vue&type=template&id=b4a97bea&"
import script from "./UserWatchlist.vue?vue&type=script&lang=js&"
export * from "./UserWatchlist.vue?vue&type=script&lang=js&"
import style0 from "./UserWatchlist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserWatchlist.vue"
export default component.exports